/* eslint-disable react/jsx-boolean-value */
import React from 'react'
import './dropdown-menu.css'

/**
 * Props to use when instantiating a `DropdownMenu` component.
 */
export interface DropdownMenuProps extends React.HTMLProps<HTMLSelectElement> {
  /**
   * All options to display in the dropdown.
   */
  options: string[] | number[]
}

/**
 * A dropdown menu, allows users to select one of several options.
 */
export function DropdownMenu({
  className,
  name,
  value,
  placeholder,
  options,
  ...otherProps
}: DropdownMenuProps) {
  return (
    <div className='dropdown-container'>
      <select
        {...otherProps}
        id={name ? `${name}-select` : 'dropdown-container'}
        className={`dropdown-input ${className}`}
        value={value || ""}
        data-testid={name ? `${name}-select-test` : 'dropdown-container-test'}
        required
      >
        <option key="placeholder" value="" disabled={true}>{placeholder || "---"}</option>
        {options.map(option => {
          return <option key={option} value={option}>{option}</option>
        })}
      </select>
    </div>
  )
}
